import { createAction, props } from '@ngrx/store';
import { Order } from '@us/web/shared/data-access';

export const loadOrders = createAction('[Orders/API] Load Orders');

export const loadOrdersSuccess = createAction('[Orders/API] Load Orders Success', props<{ orders: Order[] }>());

export const loadOrdersFailure = createAction('[Orders/API] Load Orders Failure', props<{ error: any }>());

export const loadOrder = createAction('[Orders/API] Load Order', props<{ orderId: string; localAccountId?: string }>());
export const loadOrderSuccess = createAction('[Orders/API] Load Order Success', props<{ order: Order }>());
export const loadOrderFailed = createAction('[Orders/API] Load Order Failed', props<{ error: any; orderId: string }>());

export const loadOrderPaymentStatus = createAction(
    '[Orders/API] Load Order Payment Status',
    props<{ orderId: string }>()
);

export const completeOrder = createAction('[Orders/API] Complete Order ', props<{ order: Order }>());
